import React, { useState, useRef } from "react";
import Config from "../../Config";

import PlTitle from "../../elements/PlTitle";
import StawkaNew from "./StawkaNew";

import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";


import edit from "../../edit.png";
import trash from "../../trash.png";
import InputTime from "../../helpers/InputTime";


function ContractMassFields(props)
{

   
    const [stawki, setStawki]     = useState(null);
    const [subkonta, setSubkonta] = useState(null);


    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState( {

        ids: props.ids,
        data_zawarcia: '',
        stan_umowy: '_x_',
        data_od: '',
        data_do: '',
        okres_do_wystawienia: '',

        czas_pobytu_od: '',
        czas_pobytu_do: '',

        godziny_bezplatene_1:'-1',
        godziny_bezplatene_1_od: '',
        godziny_bezplatene_1_do: '',
        sposob_naliczania_godzin: '-1',

        odsetki_ustawowe: '-1',

        roz_na_koniec_m: '-1',

    });


    const valChangeListener = (filedName, val, correct, msg) => { 
        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

 

 
 

 



    const saveData = () => {

        
        if(row.okres_do_wystawienia == null  || row.okres_do_wystawienia.length < 3 ) 
            {
              //  props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wskazano daty kolejnego rozliczenia.' ,  "ok"  ,null); 
              //  return; 
            }   



        props.mainView.setProgress(-2);
      

        fetch( Config.url + '/rest_v1_calc,umowa_zapisz_date_do_wys', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Wybrane umowy zostały zaktualizowane', "ok" , null); 
                                props.onBack();
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }








    const itemsBezplatne = [ 
        {v: '-1', title: 'Bez zmian'},
        {v: '0', title: 'Ta opcja nas nie dotyczy'},
        {v: '1', title: 'Tak, mamy bezpłatne godziny w placówce'},
        {v: '5', title: 'Tak, 5 godzin do wykorzystania w ciągu całego dnia'},
    ];


    const itemsNaliczanie = [ 
        {v: '-1', title: 'Bez zmian'},        
        {v: '0', title: 'Przelicz według deklarowanego czasu pobytu'},
        {v: '1', title: 'Według zarejestrowanych wejść i wyjść (jeśli nie ma to według deklarowanego czasu pobytu )'},
        {v: '3', title: 'Według zarejestrowanych wejść i wyjść (jeśli nie ma to ustaw 00:00)'},
    ];


    const itemsOdsetki = [  
        {v: '-1', title: 'Bez zmian'}, 
        {v: '1', title: 'Tak, naliczaj w przypadku płatności po terminie'},
        {v: '0', title: 'Nie, pomiń naliczanie odsetek'},
    ];


    const itemsRozKoniec = [   
        {v: '-1', title: 'Bez zmian'},
        {v: '0', title: 'Tak (zalecane, pierwsze dni miesiąca)'},
        {v: '1', title: 'Nie (ostatnie dni miesiąca)'},
    ];


    var itemsStanyUmowy = [
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '1',
            title: 'Umowa zawarta, generuj rozliczenia'
        },
        {
            v: '2',
            title: 'Umowa rozwiązana/zakończona'
        },
        {
            v: '3',
            title: 'Umowa czeka na podpis'
        },
    ];

 

     const itemsOds = [   
        {v: '-1', title: 'Bez zmian'},
        {v: '1', title: 'Tak, naliczaj w przypadku płatności po terminie'},
        {v: '0', title: 'Nie, pomiń naliczanie odsetek'},
    ];



    return  <div className="view_content">
            <h1><PlTitle userData={props.userData} /> / Operacja masowa / Zmiana innych elementów umowy </h1>


            <div className="form_tab_title">Wybrano umów: ({props.ids.length}) </div>    

            <div className="tip">
                 Zmień tylko te dane, które chcesz zaktualizować. Pozostałe pozostaw bez zmian. 
            </div>            
            
            <div className="form_tab">
                <div className="scroll200">
                <ul>
                {
                    props.ids.map( (item, ix) => {
                        return <li>
                                {item.title }
                        </li>
                    } )
                }
                </ul>
                </div>
            </div>

            <div className="form_tab">
                

                <div className="form_control">
                                            <div className="fieldName">Stan umowy* </div>
                                            <InputCombo   items={itemsStanyUmowy}  value={row.stan_umowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="stan_umowy" placeholder={""} className=' ' req='0'   />
                    </div>


                    <div className="form_control">
                                            <div className="fieldName">Data zawarcia  (pozostaw puste jeżeli bez zmian) </div>
                                            <InputDate   userData={props.userData} value={row.data_zawarcia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_zawarcia" placeholder={""} className=' ' req='0'   />
                    </div>

                    <br/>

                    <div className="form_control">
                                            <div className="fieldName">Obowiązuje OD  (pozostaw puste jeżeli bez zmian) </div>
                                            <InputDate   userData={props.userData} value={row.data_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={""} className=' ' req='0'   />
                    </div>

                 
                  
                    <div className="form_control">
                                            <div className="fieldName">Obowiązuje DO (pozostaw puste jeżeli bez zmian) </div>
                                            <InputDate   userData={props.userData} value={row.data_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={""} className=' ' req='0'   />
                    </div>

                    <br/>

                    <div className="form_control">
                                            <div className="fieldName">Kiedy wystawić kolejne rozliczenie do wybranych umów?  (pozostaw puste jeżeli bez zmian)  </div>
                                            <InputDate   userData={props.userData} value={row.okres_do_wystawienia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="okres_do_wystawienia" placeholder={""} className=' ' req='0'   />
                    </div>


                    <div className="form_control">
                                            <div className="fieldName">Naliczać odsetki w przypadku braku płatności?* </div>
                                            <InputCombo   items={itemsOds}  value={row.odsetki_ustawowe} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odsetki_ustawowe" placeholder={""} className=' ' req='0'   />
                    </div>


            </div>


            <div className="h_separate">
                       Kiedy są wystawiane rachunki
            </div>

            <div className="form_tab">

                    <div className="form_control">
                                      <div className="fieldName">Generuj rachunki na początku miesiąca?</div>
                                      <InputCombo  items={itemsRozKoniec} value={row.roz_na_koniec_m} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="roz_na_koniec_m" placeholder={""} className='  ' req='0'   />                                    
                    </div>

            </div>

            
            <div className="h_separate">
                       Deklarowany czas pobytu
            </div>



            <div className="form_tab_title">Deklarowany czas pobytu, sposób naliczania godzin i nadgodzin</div>
            <div className="form_tab">

                 

                    <div className="form_control">
                                            <div className="fieldName">Czas pobytu OD* </div>
                                            <InputTime   userData={props.userData} value={row.czas_pobytu_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="czas_pobytu_od" placeholder={""} className=' ' req='0'   />
                    </div>

                    <div className="form_control">
                                            <div className="fieldName">Czas pobytu DO* </div>
                                            <InputTime   userData={props.userData} value={row.czas_pobytu_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="czas_pobytu_do" placeholder={""} className=' ' req='0'   />
                    </div>


                    <div className="form_control">
                                      <div className="fieldName">Godziny bezpłatnego pobytu</div>
                                      <InputCombo  items={itemsBezplatne} value={row.godziny_bezplatene_1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godziny_bezplatene_1" placeholder={""} className='  ' req='0'   />                                    
                    </div>


                    {
                                        row.godziny_bezplatene_1 != 0 &&
                                        <React.Fragment>
                                          
                                          <div className="form_control">
                                            <div className="fieldName">Godzina od* </div>
                                            <InputTime   userData={props.userData} value={row.godziny_bezplatene_1_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godziny_bezplatene_1_od" placeholder={""} className=' ' req='0'   />
                                         </div>

                                         <div className="form_control">
                                            <div className="fieldName">Godzina do* </div>
                                            <InputTime   userData={props.userData} value={row.godziny_bezplatene_1_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godziny_bezplatene_1_do" placeholder={""} className=' ' req='0'   />
                                         </div>


                                        </React.Fragment>                                        
                    }
                    <br/>
                    <div className="form_control">
                                      <div className="fieldName">Sposób obliczania godzin pobytu</div>
                                      <InputCombo  items={itemsNaliczanie} value={row.sposob_naliczania_godzin} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sposob_naliczania_godzin" placeholder={""} className='  ' req='1'   />                                    
                    </div>


            </div>


            
            <br/>        
            <br/>        

                        <div className="form_control">                                            
                                <div className="btn" onClick={saveData}>aktualizuj</div>
                                &nbsp; &nbsp;
                                <div className="btn" onClick={props.onBack}>anuluj</div>
                        </div>


       
    </div>
}



export default ContractMassFields;